export default __webpack_public_path__ + "static/yahoo-239f321ec2020b2545a70d8f7928eaa0.svg";